export const stripToDigits = (string: string) => string.replace(/\D/g, '');

export const digitsOnlyRegExp = /^\d+$/;
